import Home from "./pages/home/Index.svelte";
import Detail from "./pages/detail/Index.svelte";
export const routes = {
    "/": Home,
    "/detail/:id": Detail,
};
